
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabs() {



    const cardData =
    {
        keyword: 'Pune to Goa Cabs',
        heading: 'Platinum24 Cabs: Pune to Goa Cabs',
        headingDescription: '  Platinum24 Cabs provides convenient Pune to Goa Cabs, perfect for family holidays, friends’ getaways, and corporate trips to the beach paradise. Our wide range of hatchbacks, sedans, SUVs, and luxury cars ensures comfort and flexibility for both short stays and extended vacations. With experienced chauffeurs, timely pickups, and affordable one-way or round-trip fares, we make your Pune to Goa journey smooth and worry-free. Whether you’re heading to North Goa’s lively beaches or South Goa’s serene resorts, Platinum24 Cabs guarantees safe, reliable, and enjoyable travel for every traveler.',

        top: 'Top Places to Visit in Goa with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is Goa’s most famous and lively beach, buzzing with nightlife, beach shacks, and water sports. Tourists enjoy parasailing, jet skiing, and dolphin cruises here. Tito’s Lane nearby is popular for clubs and parties. The beach also offers flea markets and tattoo stalls. Sunsets here are breathtaking with golden skies. Baga Beach is Goa’s ultimate hub of fun and entertainment."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, known as the ‘Queen of Beaches,’ is the largest beach in North Goa. It offers a mix of adventure and relaxation with water sports and sunbathing spots. The beach has countless cafes, shacks, and shopping stalls. It is always vibrant, especially in peak season. Families and groups find it perfect for a lively holiday. Calangute is Goa’s bustling coastal paradise."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus in Old Goa is a UNESCO World Heritage Site. Built in 1605, it houses the mortal remains of St. Francis Xavier. The baroque architecture and intricate woodwork make it a masterpiece. Pilgrims and history lovers visit year-round. The church hosts spiritual ceremonies and cultural events. Bom Jesus Basilica is Goa’s iconic heritage landmark."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, located on the Goa-Karnataka border, is one of India’s tallest waterfalls at 310 meters. Its milky white cascades resemble flowing milk, especially in monsoon. Trekkers and adventure seekers enjoy trails leading to the falls. Jeep safaris through Bhagwan Mahavir Wildlife Sanctuary add thrill. It is a favorite for nature photography. Dudhsagar is Goa’s spectacular natural wonder."
  },
  {
    "title": "Anjuna Beach & Flea Market",
    "description": "Anjuna Beach is famous for its hippie vibes, rocky shores, and lively flea market. Tourists shop for jewelry, clothes, and handicrafts at the Wednesday market. Beach shacks offer trance music and sunset views. Water sports and paragliding add adventure. Nightlife here is vibrant with parties by the sea. Anjuna is Goa’s colorful mix of culture and fun."
  },
  {
    "title": "Aguada Fort",
    "description": "Aguada Fort, built in 1612 by the Portuguese, is a massive seaside fortress overlooking the Arabian Sea. It was once a strategic defense point and a freshwater supplier for ships. The fort has a historic lighthouse that offers panoramic views. Visitors enjoy walking along its ancient walls. It is a popular sunset viewpoint. Aguada Fort is Goa’s symbol of heritage and maritime history."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is known for its crescent-shaped shoreline and calm waters. It is ideal for swimming, kayaking, and dolphin spotting. The beach is lined with colorful huts, cafes, and yoga centers. Silent Noise parties add unique nightlife experiences. The peaceful vibe attracts backpackers and couples. Palolem is Goa’s scenic and tranquil beach escape."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, made famous by the Bollywood movie ‘Dil Chahta Hai,’ overlooks the Chapora River and Vagator Beach. Built by the Portuguese in 1617, it offers panoramic sea views. The fort’s ruins are popular for photography and sunsets. Trekkers enjoy climbing the hill to reach it. Its scenic backdrop attracts tourists year-round. Chapora Fort is Goa’s cinematic and historic highlight."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach, one of South Goa’s oldest and longest beaches, stretches over 2.5 km. It is famous for its white sand, coconut palms, and lively nightlife. Tourists enjoy parasailing, jet skiing, and seafood at local shacks. The annual Fama of Menino Jesus Church adds cultural charm. Families and groups love its mix of peace and activity. Colva Beach is South Goa’s lively coastal gem."
  },
  {
    "title": "Spice Plantations",
    "description": "Goa’s spice plantations near Ponda offer a refreshing experience beyond beaches. Visitors explore plantations of cardamom, black pepper, nutmeg, and cloves. Guided tours explain spice cultivation and traditional farming. Elephant rides and local meals add to the charm. The lush greenery makes it ideal for eco-tourism. Spice plantations are Goa’s aromatic retreat into nature."
  }
],



"services": [
    {
      "name": "Pune to Goa Cab Service",
      "description": "Reliable and comfortable cab services from Pune to Goa, ideal for leisure travelers, families, and corporate trips. Enjoy smooth rides with trained chauffeurs and clean, well-maintained vehicles."
    },
    {
      "name": "Pune to Goa Cab Booking",
      "description": "Quick and easy cab booking from Pune to Goa with instant confirmation and flexible pickup options. Choose from hatchbacks, sedans, SUVs, or luxury cars to suit your travel needs."
    },
    {
      "name": "Pune to Goa Rental Cabs",
      "description": "Affordable rental cabs for your Pune to Goa journey, available in multiple car segments. Daily and trip-based rental packages available for all types of travelers."
    },
    {
      "name": "Pune to Goa One-Way Cab",
      "description": "Book a one-way cab from Pune to Goa for budget-friendly travel. Pay only for the distance you travel with no return fare and get professional service every time."
    },
    {
      "name": "Pune to Goa Round Trip Cabs",
      "description": "Round trip cab services between Pune and Goa with flexible return dates and comprehensive packages. Perfect for holidays, weekend getaways, or business tours."
    },
    {
      "name": "Pune to Goa Luxury Taxi",
      "description": "Travel in style from Pune to Goa in a luxury taxi. Enjoy top-tier comfort, entertainment features, and extra legroom in premium cars driven by experienced chauffeurs."
    },
    {
      "name": "Pune to Goa Cabs",
      "description": "Safe and reliable cab service from Pune to Goa with options for daily hire, point-to-point transfers, or multi-day trips. All vehicles are sanitized and GPS-enabled."
    },
    {
      "name": "Pune to Goa Car Rental",
      "description": "Choose from a wide range of cars for rent from Pune to Goa. Self-drive and chauffeur-driven options available with flexible pricing and full support."
    },
    {
      "name": "Pune to Goa Taxi",
      "description": "Book your Pune to Goa taxi at the best market rates. Comfortable rides, verified drivers, and on-time pickup guaranteed for your long-distance journey."
    },
    {
      "name": "Pune to Goa Taxi Fare",
      "description": "Transparent taxi fare structure for Pune to Goa travel with no hidden costs. Get quotes based on your vehicle type, trip duration, and travel dates."
    },
    {
      "name": "Pune to Goa Cab Package",
      "description": "All-inclusive cab packages for Pune to Goa travel, covering fuel, tolls, driver allowance, and optional sightseeing. Ideal for family vacations and road trips."
    },
    {
      "name": "Pune to Goa Cab Fare",
      "description": "Check accurate and up-to-date cab fare details for Pune to Goa trips across various car types like Dzire, Ertiga, Innova, and Tempo Travellers."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Top-rated cab service for the Pune to Goa route with thousands of satisfied customers, offering timely pickups, clean vehicles, and courteous drivers."
    },
    {
      "name": "Cab Service from Pune to Goa",
      "description": "Professional cab services from Pune to Goa with trained drivers and 24/7 customer support to ensure a safe and relaxed journey."
    },
    {
      "name": "Car Hire Pune to Goa",
      "description": "Hire a car from Pune to Goa with hourly, daily, or custom packages. Ideal for groups, couples, and corporate travelers needing flexibility."
    },
    {
      "name": "One Way Cab from Pune to Goa",
      "description": "One-way cabs from Pune to Goa at unbeatable rates. Avoid the extra charges of round trips and enjoy point-to-point service."
    },
    {
      "name": "Pune Goa Cab Service",
      "description": "Specialized Pune to Goa cab service that caters to long-distance comfort, road safety, and premium travel experiences for every customer."
    },
    {
      "name": "Pune to Goa Cab Cost",
      "description": "Affordable cab costs for Pune to Goa journeys with options for custom quotes depending on your group size, car preference, and trip duration."
    },
    {
      "name": "Pune to Goa Cab Charges",
      "description": "Compare cab charges for Pune to Goa service across multiple vehicle types and find the best deals for your planned travel dates."
    },
    {
      "name": "Pune to Goa Cab Booking",
      "description": "Instant cab booking from Pune to Goa with reliable operators and a wide range of vehicle choices. Online and phone bookings available."
    },
    {
      "name": "Pune to Goa Cab Rental",
      "description": "Flexible cab rental services from Pune to Goa offering hourly, daily, and full-trip plans for all travel preferences."
    },
    {
      "name": "Pune to Goa Cab Service Fare",
      "description": "Know the standard fare for Pune to Goa cab services with detailed breakdowns including fuel, toll, and driver allowance."
    },
    {
      "name": "Pune to Goa Cab Service Rates",
      "description": "Detailed rate charts for Pune to Goa cab services, helping travelers pick the best package for their needs and budget."
    },
    {
      "name": "Pune to Goa Innova Rental",
      "description": "Rent an Innova or Innova Crysta for your Pune to Goa trip. Spacious, comfortable, and ideal for group or family travel with ample luggage space."
    },
    {
      "name": "Pune to Goa One Way Taxi",
      "description": "Affordable and comfortable one-way taxi from Pune to Goa, with experienced drivers and well-maintained vehicles to ensure a smooth ride."
    },
    {
      "name": "Pune to Goa Taxi Service",
      "description": "Premium taxi services from Pune to Goa with verified drivers, safe vehicles, and on-time pickup. Choose from economy or premium cars as per your budget."
    }
  ],
  "tableData": [
    ["Pune to Goa Cab Service", "Pune to Goa Cab Booking"],
    ["Pune to Goa Rental Cabs", "Pune to Goa One-Way Cab"],
    ["Pune to Goa Round Trip Cabs", "Pune to Goa Luxury Taxi"],
    ["Pune to Goa Cabs", "Pune to Goa Car Rental"],
    ["Pune to Goa Taxi", "Pune to Goa Taxi Fare"],
    ["Pune to Goa Cab Package", "Pune to Goa Cab Fare"],
    ["Best Cab Service from Pune to Goa", "Cab Service from Pune to Goa"],
    ["Car Hire Pune to Goa", "One Way Cab from Pune to Goa"],
    ["Pune Goa Cab Service", "Pune to Goa Cab Cost"],
    ["Pune to Goa Cab Charges", "Pune to Goa Cab Booking"],
    ["Pune to Goa Cab Rental", "Pune to Goa Cab Service Fare"],
    ["Pune to Goa Cab Service Rates", "Pune to Goa Innova Rental"],
    ["Pune to Goa One Way Taxi", "Pune to Goa Taxi Service"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Goa Cabs for Comfortable Travel",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and reliable cab services for your Pune to Goa journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long-Distance Trips",
        "WhyChoosedescription": "Enjoy ample legroom and comfort in our well-maintained cabs, perfect for the scenic Pune to Goa route."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We prioritize your health with regular cleaning and sanitization of all vehicles before every trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Goa Routes",
        "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth, safe, and timely journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from customizable packages to fit your travel itinerary between Pune and Goa."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for worry-free travel."
    },
    {
        "WhyChooseheading": "Ideal for Family Vacations, Group Tours, and Corporate Trips",
        "WhyChoosedescription": "Our Pune to Goa cab services cater to all travel needs, from leisure to business."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings, changes, and special requests."
    }
]
















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune to Goa?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services for travel between Pune and Goa.',
    },
    {
        question: 'How can I book a Pune to Goa cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Goa cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Goa trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Goa?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Goa route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Goa?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Goa cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Goa rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Goa route.',
    },
    {
        question: 'Are safety measures in place for Pune to Goa cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Goa travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Goa?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Goa routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Desai',
        feedback: 'The Pune to Goa cab service by Platinum24 Cabs was excellent. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Rane',
        feedback: 'I had a wonderful trip to Goa with Platinum24 Cabs. The booking process was easy and the service was top-notch.',
        rating: 5,
    },
];
































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToGoaCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-goa-cabs.jpg",
  "description": "Book Pune to Goa cabs with Platinum24 Cabs. Reliable one-way and round trip taxi services including luxury and rental options, perfect for comfortable travel from Pune to Goa.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "11000",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-goa-cabs"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Goa Cabs | One-Way & Round Trip Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Goa cabs with Platinum24 Cabs. Reliable one-way and round trip taxi services including luxury and rental options, perfect for comfortable travel from Pune to Goa."
  />
  <meta
    name="keywords"
    content="Pune to Goa Cab Service, Pune to Goa Cab Booking, Pune to Goa Rental Cabs, Pune to Goa one-way cab, Pune to Goa Round Trip Cabs, Pune to Goa Luxury Taxi, pune to goa cabs, Pune to Goa Car Rental, Pune to Goa Taxi, Pune to Goa Taxi fare, Pune to Goa Cab Package, Pune to Goa cab fare, Best cab service from pune to Goa, Cab service from pune to Goa, Car Hire Pune to Goa, One way cab from pune to Goa, Pune Goa Cab Service, Pune to Goa Cab Cost, pune to goa cab charges, Pune to goa cab booking, pune to goa cab rental, Pune to goa cab service fare, Pune to goa cab service rates, Pune to Goa Innova Rental, Pune to Goa one way cab, Pune to Goa one way taxi, Pune to goa taxi service"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGoaCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoacabs;